/* istanbul ignore file */

import React, { useEffect, useContext, useState } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { useFilterBook } from '@catalogo/ui-americanas-desktop-product-review/src/hooks';
import { Review, ReviewSkoob } from '../../../molecules';

const SetReview = (props: any) => {
  const { dispatchMetrics } = props;
  const [reviews, setReviews] = useState([]);
  const { config, data } = useContext(context);
  const { breadcrumb, productName } = config;
  const { isBook } = useFilterBook({ breadcrumb });

  const renderReviews = reviews?.map((review: any) => {
    const { badges, createdAt, feedback, id, owner, rating, text } = review;
    const { downVotes, upVotes } = feedback;

    if (isBook) {
      return (
        <ReviewSkoob
          productName={productName}
          key={id}
          id={id}
          owner={owner}
          rating={rating}
          review={text}
          date={createdAt}
          upVotes={upVotes}
          downVotes={downVotes}
          badges={badges}
          isVerifiedPurchaser={!!badges.length}
          dispatchMetrics={dispatchMetrics}
        />
      );
    }

    return (
      <Review
        key={id}
        id={id}
        owner={owner}
        rating={rating}
        review={text}
        date={createdAt}
        upVotes={upVotes}
        downVotes={downVotes}
        badges={badges}
        isVerifiedPurchaser={!!badges.length}
        dispatchMetrics={dispatchMetrics}
      />
    );
  });

  useEffect(() => {
    setReviews(data.reviews || []);
  }, [data]);

  return <>{renderReviews}</>;
};

export default SetReview;
export { SetReview };
